export function ErrorMessage({ text }: { text: string }) {
  return <span className="text-red-500">{text}</span>;
}
